import { ExportEmailDrawerTranslations } from "./export-email-drawer-pt-br";

export const EXPORT_EMAIL_DRAWER_EN_US: ExportEmailDrawerTranslations = {
	title: "Exports",
	description:
		"Enter your email to receive the spreadsheet. We will send the spreadsheet in a few minutes and it will also be available in 'Exported spreadsheets' for 7 days.",
	form: {
		label: "Email",
		placeholder: "Enter your email",
		required: "Email is required",
		emailInvalid: "Email is invalid",
		submit: "Export spreadsheet",
	},
};
